import React from 'react'

import Checkbox from './Checkbox'

const Radio = props => <Checkbox {...props} circle />

export default Radio
